
function install (Vue) {
  let mainStore = null
  const business = {
    /**
     * 存储基座sdk操作
     */
    initSocket (res) {
      mainStore = res
    },

    /* 设备加入场景 */
    deviceJoinScene (sceneName, deviceList) {
      mainStore.commit('deviceJoinScene', {
        sceneName, deviceList
      })
    },

    /* 批量取消订阅设备 */
    resetDeviceIdList (deviceList) {
      mainStore.resetDeviceIdList(deviceList || [])
    },

    // 批量订阅设备状态()
    addSubscriptionDevice (device) {
      mainStore.addSubscriptionDevice(device)
    },

    // 重启 or 关机
    shutdownOrRestart (obj, successCallback, failCallback) {
      mainStore.commit('shutdownOrRestart', {
        obj, successCallback, failCallback
      })
    },

    // 白光灯设置
    whiteLightSwitch (obj, successCallback, failCallback) {
      mainStore.commit('whiteLightSwitch', {
        obj, successCallback, failCallback
      })
    },

    // 定位上传间隔
    locationFrequency (obj, successCallback, failCallback) {
      mainStore.commit('locationFrequency', {
        obj, successCallback, failCallback
      })
    },

    // 近电预警设置
    nearEleSet (obj, successCallback, failCallback) {
      mainStore.commit('nearEleSet', {
        obj, successCallback, failCallback
      })
    },

    // 音量设置
    volumeSet (obj, successCallback, failCallback) {
      mainStore.commit('volumeSet', {
        obj, successCallback, failCallback
      })
    },

    // 音量获取
    volumeGet (obj, successCallback, failCallback) {
      mainStore.commit('volumeGet', {
        obj, successCallback, failCallback
      })
    },

    // wifi 列表获取
    wifiGet (obj, successCallback, failCallback) {
      mainStore.commit('wifiGet', {
        obj, successCallback, failCallback
      })
    },

    // wifi 连接
    wifiSet (obj, successCallback, failCallback) {
      mainStore.commit('wifiSet', {
        obj, successCallback, failCallback
      })
    },

    /* 连接状态 */
    connectionStatus () {
      return mainStore.getters.businessConnectionStatus()
    },

    // 批量订阅设备状态()
    bulkSubscriptionDevice (deviceList) {
      mainStore.bulkSubscriptionDevice(deviceList)
    },

    /* 设备指令 */
    equipmentDirective (device, successCallback, failCallback) {
      mainStore.commit('equipmentDirective', {
        device,
        successCallback,
        failCallback
      })
    },

    /* 查询⽇期列表 */
    deviceQueryFileDates (obj, successCallback, failCallback) {
      mainStore.commit('deviceQueryFileDates', {
        obj,
        successCallback,
        failCallback
      })
    },

    /* 查询⽂件列表 */
    deviceQueryFiles (obj, successCallback, failCallback) {
      mainStore.commit('deviceQueryFiles', {
        obj,
        successCallback,
        failCallback
      })
    },

    /* 设备文件上传 */
    deviceUploadFile (obj, successCallback, failCallback) {
      mainStore.commit('deviceUploadFile', {
        obj,
        successCallback,
        failCallback
      })
    },

    /* 移除场景中订阅的设备 */
    deleteSceneDevice (sceneName) {
      mainStore.commit('deleteSceneDevice', sceneName)
    },

    /* 根据场景订阅的设备 */
    addSceneDevice (obj) {
      mainStore.commit('addSceneDevice', {
        obj
      })
    },

    /* 聊天新增订阅 */
    chatSubscribe (roomId, chatMessageCallback) {
      mainStore.commit('chatSubscribe', {
        roomId,
        chatMessageCallback
      })
    },

    /* 聊天取消订阅 */
    chatUnsubscribe (roomId) {
      mainStore.commit('chatUnsubscribe', roomId)
    },

    /* 视频会议新增订阅 */
    videoMeetingSubscribe (roomId, chatMessageCallback) {
      mainStore.commit('videoMeetingSubscribe', {
        roomId,
        chatMessageCallback
      })
    },

    /* 视频会议取消订阅 */
    videoMeetingUnsubscribe (roomId) {
      mainStore.commit('videoMeetingUnsubscribe', roomId)
    },

    /* 画板新增订阅 */
    canvasSubscribe (roomId, chatMessageCallback) {
      mainStore.commit('canvasSubscribe', {
        roomId,
        chatMessageCallback
      })
    },

    /* 画板取消订阅 */
    canvasUnsubscribe (roomId) {
      mainStore.commit('canvasUnsubscribe', roomId)
    },

  }
  Vue.prototype.$business = Object.assign({}, business)
}
export default install
